"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const de_ui_1 = require("@delab-team/de-ui");
const passwordInput_module_css_1 = __importDefault(require("./passwordInput.module.css"));
const svg_selector_1 = require("../../assets/svg-selector");
const PasswordInput = ({ inputTitle, onChange, placeholder }) => {
    // custom input
    const TgObj = sdk_1.default;
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    const togglePasswordVisibility = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        setShowPassword(!showPassword);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: passwordInput_module_css_1.default.passwordInner, children: [(0, jsx_runtime_1.jsxs)("div", { className: passwordInput_module_css_1.default.passwordWrapper, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: passwordInput_module_css_1.default.passwordLabel, children: inputTitle }), (0, jsx_runtime_1.jsx)("input", { type: showPassword ? 'text' : 'password', placeholder: placeholder, onChange: onChange, className: passwordInput_module_css_1.default.passwordInput })] }), (0, jsx_runtime_1.jsx)(de_ui_1.Button, { className: passwordInput_module_css_1.default.eyeBtn, onClick: togglePasswordVisibility, children: showPassword ? (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "open-eye" }) : (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "close-eye" }) })] }));
};
exports.PasswordInput = PasswordInput;
